import { Injectable } from '@angular/core';
import { Fetcher } from '@shared/http/fetcher';
import type { CheckIn } from '@shared/modules/check-ins/check-in';

@Injectable({
    providedIn: 'root',
})
export class CheckInFetcher extends Fetcher<CheckIn> {
    readonly modelName: string = 'CheckIn';

    get resourceName(): string {
        return 'check-ins';
    }
}
